import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { PointsAmountBanner as PointsAmountBannerBase } from "./PointsAmountBanner";

export type * from "./PointsAmountBanner";
export const PointsAmountBanner = withLoyaltyStore(PointsAmountBannerBase, "PointsAmountBanner");
